import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./KazakhstanHivTreatment.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getKazakhstanRemoteMigrationDetails,
  getKazakhstanTripPreparationDetails,
  getRussiaHiVMigrantsDetails,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const KazakhstanHivTreatment = () => {
  const data = useSelector(
    (state: RootState) => state.info.kazakhstanTripPreparationDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getKazakhstanTripPreparationDetails(Number(params.id)));
  }, [params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Лечение ВИЧ для иностранцев и мигрантов в Казахстане"
        description="В каких случаях иностранцы с ВИЧ, имеют право на бесплатное лечение в Казахстане. Как получать лечение, если у мигранта нет вида на жительство?"
        url="https://www.vputi.org/kazakhstan/hiv/treatment/2"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство Казахстана / Для мигрантов, живущих с ВИЧ  / Как получать лечение?",
            path: "/kazakhstan/hiv/1",
          }}
        />

        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.yellow_wrapper}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_2 ?? "" }}
          ></div>
          <div className={s.title2}>{data?.title_3}</div>
          <div
            className={s.body1}
            dangerouslySetInnerHTML={{ __html: data?.body_3 ?? "" }}
          ></div>
          <div
            className={s.body2}
            dangerouslySetInnerHTML={{ __html: data?.body_4 ?? "" }}
          ></div>
          <div className={s.btn_wrapper}>
            <Link
              to="/kazakhstan/hiv/treatment/remote/1"
              className={s.btn_wrapper}
            >
              <div
                className={s.migration_btn}
                onClick={() => dispatch(getKazakhstanRemoteMigrationDetails(1))}
              >
                {t("Дистанционный учет")}
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default KazakhstanHivTreatment;
